import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { D2cService } from "../../services/d2c-service.service";
import { MatDialogSizeService } from "src/app/shared/services/mat-dialog-size";
import { TermsAndConditionsComponent } from "src/app/shared/dialogs/terms-and-conditions/terms-and-conditions.component";
import { UntilDestroy } from "@ngneat/until-destroy";
import { catchError, finalize, from, map, of, Subscription, switchMap } from "rxjs";
import { LoanDashboardService } from "src/app/loan-layout/components/loan-dashboard/loan-dashboard.service";
import { StoreService } from "src/app/shared/services/store.service";
import { TimelineService } from "src/app/loan-layout/components/loan-dashboard/components/timeline/timeline.service";
import { TERMS_AND_CONDITIONS_CIBIL_URL } from "../../d2c.interface";

@UntilDestroy({ arrayName: "subscriptions" })
@Component({
    selector: "web-cibil-conformation",
    templateUrl: "./cibil-conformation.component.html",
    styleUrls: ["./cibil-conformation.component.scss"],
})
export class CibilConformationComponent implements OnInit {
    subscriptions: Subscription[] = [];
    consentForm!: FormGroup;
    DTCDialogue = false;
    isContinue = false;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<CibilConformationComponent>,
        private router: Router,
        private d2cService: D2cService,
        private dialog: MatDialog,
        private matDialogSizeService: MatDialogSizeService,
        private loanDashboardService: LoanDashboardService,
        private timelineService: TimelineService,
        private storeService: StoreService
    ) {}

    ngOnInit(): void {
        this.DTCDialogue = history.state?.DTCDialogue || false;

        this.consentForm = this.fb.group({
            isChecked: [false],
        });
    }

    onContinue(): void {
        if (!this.consentForm.get("isChecked")?.value) {
            return;
        }

        if (this.DTCDialogue) {
            this.isContinue = true;
            this.subscriptions.push(
                this.loanDashboardService
                    .applyLoan(true)
                    .pipe(
                        map((res: any) => {
                            if (res.success) {
                                this.goToNextStep();
                            }
                            this.isContinue = false;
                        }),
                        catchError(() => {
                            this.isContinue = false;
                            this.loanDashboardService.getDashboardDetails(true);
                            return of(null);
                        })
                    )
                    .subscribe()
            );
        } else {
            this.isContinue = true;

            this.d2cService.getNewCibil().subscribe((res) => {
                this.isContinue = false;

                if (res?.success) {
                    this.storeService.set({
                        key: "fromD2cDetails",
                        value: "CIBIL_CONFIRMATION",
                    });
                    this.router.navigate(["/d2c/details"]);
                }
            });
        }
    }

    notNow(): void {
        if (this.DTCDialogue) {
            this.loanDashboardService.getDashboardDetails();
        } else {
            this.router.navigate(["/d2c/details"]);
        }
    }

    viewTermsAndConditions() {
        this.dialog.open(TermsAndConditionsComponent, {
            width: this.matDialogSizeService.wVII,
            disableClose: true,
            data: TERMS_AND_CONDITIONS_CIBIL_URL,
        });
    }

    goToNextStep() {
        this.isContinue = true;
        this.loanDashboardService
            .getDashboardDetails$(false, false)
            .pipe(
                switchMap((res) => from(this.timelineService.goToNextStep(res))),
                finalize(() => (this.isContinue = false))
            )
            .subscribe({
                error: () => (this.isContinue = false),
            });
    }
}
